export default __webpack_public_path__ + "static/media/surat-jalan-kasir.2e29b65d.png";